<template>
  <v-card>
    <v-card-title class="section-title pt-6 pb-2 mb-0">
      <span>Configurações dos Hotsites</span>
      <v-spacer />
      <add-hotsite-slot :add-hotsite-fn="addHotsite" />
    </v-card-title>
    <v-card-text>
      Para editar um hotsite, clique na linha correspondente na tabela abaixo.
      <paginated-data-table ref="table" :headers="headers" :query="query" query-name="hotsiteSlots" query-main-property-name="slots">
        <template v-slot:item="{ item }">
          <tr class="cursor-pointer" @click="goToHotsiteSlot(item)">
            <td>
              {{ item.name }}
            </td>
            <td>
              <v-chip v-for="url in item.urls" :key="url" class="mr-2">
                {{ url }}
              </v-chip>
            </td>
            <td>
              {{ item.latest_version }}
            </td>
          </tr>
        </template>
      </paginated-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { LIST_HOTSITE_SLOTS, ADD_HOTSITE_SLOT } from '@/modules/configuracoes/site-de-cadastramento/graphql'

export default {
  name: 'HotsiteSlotsTable',
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
    AddHotsiteSlot: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/AddHotsiteSlot.vue'),
  },
  data: () => ({
    headers: [
      {
        text: 'Nome',
        value: 'name',
      },
      {
        text: 'URLs',
        value: 'urls',
      },
      {
        text: 'Versão mais recente',
        value: 'latest_version',
        width: 200,
      },
    ],
  }),
  computed: {
    query() {
      return LIST_HOTSITE_SLOTS
    },
  },
  methods: {
    goToHotsiteSlot(hotsiteSlot) {
      this.$router.push({
        name: 'edit-hotsite-slot',
        params: {
          id: hotsiteSlot._id,
        },
      })
    },
    async addHotsite(name) {
      await this.$apollo.mutate({
        mutation: ADD_HOTSITE_SLOT,
        variables: { name },
      })
      this.$refs.table.waitAndGetData()
    },
  },
}
</script>
